export enum BarPluginId {
  HorizontalLine = 'horizontalLine'
}
